export const textMimeTypes = new Set([
    'plain/text',
    'text/html',
    'text/css',
    'text/xml',
    'text/csv',
    'text/javascript',
    'application/json',
    'application/ld+json',
    'application/xml',
    'application/xhtml+xml',
    'application/atom+xml',
    'application/javascript',
    'application/x-javascript',

    'image/svg+xml',
]);

export const binaryMimeTypes = new Set([
    'font/woff2',
    'font/ttf',

    'image/gif',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/webp',
    'image/bmp',
]);

export const safeMeasurableTypes = new Set([
    ...textMimeTypes.values(),
    ...binaryMimeTypes.values(),
]);
